import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col, Form, Button, Alert, FloatingLabel } from "react-bootstrap"

const PasswordReset = () => {
  const successMessage = "Email pro obnovení byl odeslán."
  const [email, setEmail] = useState("")
  const [uzivatel, setUzivatel] = useState("")
  const [message, setMessage] = useState(null)
  const [error, setError] = useState(null)
  const [validated, setValidated] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setMessage(null)
      setError(null)
    }, 3000)

    return () => clearTimeout(timer)
  }, [error, message])

  const handleResetPassword = async (e) => {
    e.preventDefault()
    const form = e.currentTarget

    if (form.checkValidity() === false) {
      e.stopPropagation()
      setValidated(true)
      return
    }

    setValidated(true)

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login/overit/email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, uzivatel }),
      })

      if (!response.ok) {
        const errorResponse = await response.json().catch(() => ({}))
        throw new Error(errorResponse.message || "Účet nebyl nalezen.")
      }

      const data = await response.json().catch(() => null)
      setMessage(data?.message || successMessage)
    } catch (requestError) {
      setError(requestError.message)
    }
  }

  return (
    <Container fluid className="vh-100 d-flex align-items-center justify-content-center bg-primary px-5">
      <div className="login-container shadow-lg rounded-4 overflow-hidden mx-sm-5">
        <Row className="g-0">
          <Col md={6} className="p-5 bg-white order-2 order-md-1">
            <Form noValidate validated={validated} onSubmit={handleResetPassword} className="h-100 d-flex flex-column justify-content-center">
              <h3 className="mb-4">Změna hesla</h3>

              <Form.Group className="mb-2" controlId="formUzivatel">
                <FloatingLabel controlId="uzivatel" label="Uživatelské jméno">
                  <Form.Control
                    className="rounded-pill"
                    type="text"
                    placeholder="Uživatelské jméno"
                    value={uzivatel}
                    maxLength={32}
                    onChange={(e) => setUzivatel(e.target.value)}
                    required
                  />
                  <Form.Control.Feedback type="invalid">Uveďte uživatelské jméno.</Form.Control.Feedback>
                </FloatingLabel>
              </Form.Group>

              <Form.Group className="mb-4" controlId="formEmail">
                <FloatingLabel controlId="email" label="Emailová adresa">
                  <Form.Control
                    className="rounded-pill"
                    type="email"
                    placeholder="Emailová adresa"
                    value={email}
                    maxLength={64}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <Form.Control.Feedback type="invalid">Uveďte emailovou adresu.</Form.Control.Feedback>
                </FloatingLabel>
              </Form.Group>

              <div className="mb-4">
                <Link to="/login" className="text-muted small">Zpět k přihlášení</Link>
              </div>

              <Button type="submit" size="lg" className="w-100 rounded-pill py-2">
                Odeslat
              </Button>

              {message && (
                <Alert variant="success" className="mt-3 rounded-pill py-2">
                  <i className="bi bi-check2 pe-2"></i>
                  {message}
                </Alert>
              )}

              {error && (
                <Alert variant="danger" className="mt-3 rounded-pill py-2">
                  <i className="bi bi-exclamation-triangle pe-2"></i>
                  {error}
                </Alert>
              )}
            </Form>
          </Col>

          <Col md={6} className="bg-primary text-white d-flex flex-column justify-content-center align-items-center p-4 position-relative order-1 order-md-2">
            <svg
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{ opacity: 0.1, zIndex: 0 }}
              viewBox="1700 0 17000 17000"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8469.39 4560.02v3344.05l1836.83-1081.97 1836.83 1081.97V4560.02l-1836.83-1081.96-1836.83 1081.96zm1836.83 9195.12h1836.83v-500.87l-1836.83-1081.97-1836.83 1081.97v500.87h1836.83zm1836.83-4848v3344.05l-1836.83-1081.96-1836.83 1081.96V8907.14l1836.83-1081.96 1836.83 1081.96zM7617.87 8405.66V5061.62L5202.73 6484.23l-.03 3344.04zM7617.87 12752.78V9408.74l-2415.14 1422.61v1767.97c0 513.88 339.93 952.19 805.98 1101.32l1609.16-947.86zM6358.55 3478.06h1259.32v580.48L5202.73 5481.12v-847.24c0-635.7 520.12-1155.82 1155.82-1155.82zM12994.57 8405.66V5061.62l2415.14 1422.61.03 3344.04zM12994.57 12752.78V9408.74l2415.14 1422.61v1767.97c0 513.88-339.93 952.19-805.98 1101.32l-1609.16-947.86zM14253.89 3478.06h-1259.32v580.48l2415.14 1422.58v-847.24c0-635.7-520.12-1155.82-1155.82-1155.82z"/>
            </svg>
            <div style={{ zIndex: 1 }} className="text-center">
              <i className="bi bi-journal-text display-3"></i>
              <h3 className="mt-3">Uživatelský přístup</h3>
              <p>Zadejte uživatelské jméno a email. Pokud údaje odpovídají účtu, odešleme odkaz pro změnu hesla.</p>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  )
}

export default PasswordReset
